// extracted by mini-css-extract-plugin
export default {"nonMobileWrapper":"_8f3ae762","isMobileWrapper":"_4d3d4717"};